import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

// ******************************************* GS Overview *************************************************************

export const getGSOverViewList = async (data) => {
    return decryptData(
        await axios.get(
            `/getGSOverViewList?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getGsOverviewByID = async (data) => {
    return decryptData(
        await axios.get(
            `/getGsOverviewByID?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const editGSOverview = async (data) => {
    return decryptData(
        await axios.post(`/editGSOverview`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

// ******************************************* GS Notes *************************************************************

export const getGSNotesList = async (data) => {
    return decryptData(
        await axios.get(
            `/getGSNotesList?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const GetGSSubjectsList = async (data) => {
    return decryptData(
        await axios.get(
            `/GetGSSubjectsList?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const addGSSubject = async (data) => {
    return decryptData(
        await axios.post(`/addGSSubject`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const editGSSubject = async (data) => {
    return decryptData(
        await axios.post(`/editGSSubject`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const updateStatusGSSubject = async (data) => {
    return decryptData(
        await axios.post(`/updateStatusGSSubject `, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const getGSChaptersList = async (data) => {
    return decryptData(
        await axios.get(
            `/getGSChaptersList?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getGSChapterById = async (data) => {
    return decryptData(
        await axios.get(
            `/getGSChapterById?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const addGSChapter = async (data) => {
    return decryptData(
        await axios.post(`/addGSChapter `, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const editGSChapter = async (data) => {
    return decryptData(
        await axios.post(`/editGSChapter `, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const updateStatusGSChapter = async (data) => {
    return decryptData(
        await axios.post(`/updateStatusGSChapter `, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};


export const updateChapterDisplayorder = async (data) => {
    return decryptData(
        await axios.get(
            `/edit-chapter-display-order?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};